module.exports = __webpack_public_path__ + "fonts/ca0cad13/aboutme-glyphs.woff2";